import { render } from "./ViewerTool.vue?vue&type=template&id=4bd9ff03&scoped=true"
import script from "./ViewerTool.vue?vue&type=script&lang=js"
export * from "./ViewerTool.vue?vue&type=script&lang=js"

import "./ViewerTool.vue?vue&type=style&index=0&id=4bd9ff03&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bd9ff03"]])

export default __exports__